import { Student } from "../UnitReport.tsx";
import Heading from "./Heading.tsx";

type VideoLinkType = {
  student: Student,
  background: string,
  bg: string,
  color: string
}

export default function VideoLinks({student,background,bg,color}:VideoLinkType) {


    return (
    <div>
        <Heading
          label="KẾT QUẢ ĐÁNH GIÁ"
          background={background}
        />
        <div style={{ background: bg, color }} className="flex justify-between">
        <TestVideo />
        <AdvancedReading />
           
             
             
        </div>
    </div>
         
      
    );
}


function TestVideo() {
    
    return (
      <div className="flex flex-1 flex-col">
        <div
          className="flex-1 text-center p-2"
          style={{ borderLeft: "black 1px solid" }}
        >
          Link video bài test
        </div>
        <div className="flex flex-1 h-10">
          <div className="flex-1 border border-black p-2 h-10"></div>
          <div
            className="flex-1 p-2 h-10"
            style={{
              borderTop: "1px solid black",
              borderBottom: "1px solid",
            }}
          ></div>
        </div>
      </div>
    );
}

    function AdvancedReading() {
      return (
        <div className="flex flex-1 flex-col">
          <div
            className="flex-1 text-center p-2 h-10"
            style={{
              borderLeft: "black 1px solid",
              borderRight: "black 1px solid",
            }}
          >
            Số lượng bài đọc mở rộng/nâng cao
          </div>
          <div className="flex flex-1 text-center p-2 border-black border h-10"></div>
        </div>
      );
    }